import React, { useState, useEffect } from "react";
import { Nav, Table } from "react-bootstrap";
import { PrimaryButton } from "@fluentui/react/lib/Button";
import { TextField, Dropdown, DatePicker } from "@fluentui/react";
import { Stack } from "@fluentui/react/lib/Stack";
import "bootstrap/dist/css/bootstrap.min.css";
import currentstage from "../../../../assets/img/currentstage.svg";
import { tabData, formData, buttonData } from "./EditDumy";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ResourceEdit from "./ResourceEdit";
import BasicDetailEdit from "./BasicDetailEdit";
import CostTabContent from "./CostTabContent";
import FundingTab from "./Funding";
import WorkOrderTab from "./WorkOrder";
import ROIComponent from "./ROIComponent";
import StageComponent from "./StageComponent";
import TimelinesComponent from "./TimelinesComponent";
import DocumentsComponent from "./DocumentsComponent";
import WorkflowTabs from "./WorkFlow";
import Discussion from "./Discussion";
import InitiativeHistoryTab from "./InitiativeHistoryTab";
import MoreActions from "./MoreActions";

import GetInitiativeDetail from "../../../hooks/Editpage/GetInitiativeDetail";
import GetInitiativeROIList from "../../../hooks/Editpage/GetInitiativeROIList";
import GetInitiativeStageList from "../../../hooks/Editpage/GetInitiativeStageList";
import GetInitiativeDocumentList from "../../../hooks/Editpage/GetInitiativeDocumentList";
import GetInitiativeTimeline from "../../../hooks/Editpage/GetInitiativeTimeline";
import GetInitiativeResourceList from "../../../hooks/Editpage/GetInitiativeResourceList";
import GetInitiativeCostList from "../../../hooks/Editpage/GetInitiativeCostList";
import GetInitiativeWorkOrderList from "../../../hooks/Editpage/GetInitiativeWorkOrderList";
import GetInitiativeFundList from "../../../hooks/Editpage/GetInitiativeFundList";
import GetInitiativeDiscussion from "../../../hooks/Editpage/GetInitiativeDiscussion";
import GetInitiativeHistory from "../../../hooks/Editpage/GetInitiativeHistory";
import GetInitiativeLinkAccess from "../../../hooks/Editpage/GetInitiativeLinkAccess";
import GetInitiativeWorkFlow from "../../../hooks/Editpage/GetInitiativeWorkFlow";
import GetInitiativeRisks from "../../../hooks/Editpage/GetInitiativeRisks";
import GetInitiativeRisksHeat from "app/hooks/Editpage/GetInitiativeRisksHeat";
import GetInitiativeActioItems from "../../../hooks/Editpage/GetInitiativeActioItems";
import GetPrioritizationCheckList from "app/hooks/Editpage/GetPrioritizationCheckList";
import { ref } from "yup";
// Added by Gauri for Role Access on 06 May 2025
import useGetViewOptions from "app/hooks/useGetViewOptions";
import AxiosInstance1 from "app/hooks/AxiosInstance/AxiosInstance1";
import { useLocation, useNavigate, useParams } from "react-router-dom";
// Added by Gauri to add loader on 14 Nov 2025
import 'app/views/common/Loader.css';

{
  /* Passed initiatives by Gauri for manage workflow stages on 24 Mar 2025 */
}
const EditPage = ({
  ideaID,
  initiatives,
  // Added By Madhuri.K On 08-07-2025
  natureofDemandID,
  natureOfDemandRevisionID,
  natureofDemand,
  initiativesID,
  setIsEditing = () => {},
  image,
  setRefresh12 = () => {}, 
  refresh12 = false,
  show,
  // Added By Madhuri.K On 10-10-2025
  currentView = 'list',
  IsConverted
}) => {
  const [activeTab, setActiveTab] = useState("basic-details");
  const [activeTab1, setActiveTab1] = useState("");
  const [tabsData, setTabsData] = useState([]);
  const [showMore, setShowMore] = useState(false);
  const [tabsToShow, setTabsToShow] = useState(4);
  const [formDataState, setFormDataState] = useState({
    natureOfInitiative: "",
    initiativeCode: "",
    businessGroup: null,
    organizationUnit: null,
    plannedStart: null,
    plannedEnd: null,
  });
  const [userID, setUserID] = useState(null);
  const [refetch, setRefetch] = useState(false);
  const [initiativeDetail, setInitiativeDetail] = useState(null);
  const [initiativeROI, setInitiativeROI] = useState(null);
  const [initiativeStage, setInitiativeStage] = useState(null);
  const [initiativeDocument, setInitiativeDocument] = useState(null);
  const [initiativeTimeline, setInitiativeTimeline] = useState(null);
  const [initiativeResource, setInitiativeResource] = useState(null);
  const [initiativeCost, setInitiativeCost] = useState(null);
  const [initiativeWorkOrder, setInitiativeWorkOrder] = useState(null);
  const [initiativeFund, setInitiativeFund] = useState(null);
  const [initiativeDiscussion, setInitiativeDiscussion] = useState(null);
  const [initiativeHistory, setInitiativeHistory] = useState(null);
  const [initiativeLinkAccess, setInitiativeLinkAccess] = useState(null);
  const [initiativeWorkFlow, setInitiativeWorkFlow] = useState(null);
  {
    /* Passed initiativesData by Gauri for manage workflow stages on 24 Mar 2025 */
  }
  const [initiativesData, setInitiativesData] = useState(null);
  const [initiativeRisks, setInitiativeRisks] = useState(null);
  const [acc, setAcc] = useState([]);
  const [initiativeRisksHeat, setInitiativeRisksHeat] = useState(null);
  const [initiativeActioItems, setInitiativeActioItems] = useState(null);
  const [prioritizationCheckList, setPrioritizationCheckList] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const { id } = useParams();
  // Added by Gauri for Role Access on 06 May 2025
  const tagId = 2173;
  // Added by Gauri to add loader on 14 Nov 2025
  const { getViewOptions, loading: permissionsLoading } = useGetViewOptions(tagId?.toString() ?? "");
  const viewPermission = getViewOptions && getViewOptions[0] ? getViewOptions[0] : {};
  const { a: canAdd, e: canEdit, d: canDelete, v: canView } = viewPermission;
  const hasAnyPermission = canAdd || canEdit || canDelete || canView;
  // Added by Gauri to add loader on 14 Nov 2025
  const [initialLoading, setInitialLoading] = useState(true);
  const [tabLoading, setTabLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const workOrderTabPermission = getViewOptions?.[4] || {};
  console.log("workOrderTabPermission", workOrderTabPermission);

  // Modified by Gauri to Find Document Upload tab by tagname instead of array index on 13-10-2025
  const docTabPermission = getViewOptions?.find(option => option.tagname === "Document Upload") || {};
  console.log("docTabPermission", docTabPermission);

  const initiativeId = id;
  
  // Added By Madhuri.K On 09-10-2025 - Store Page Level Access for tab filtering
  const [pageLevelAccess, setPageLevelAccess] = useState([]);

  // Added By Madhuri.K On 10-10-2025 - Get previous view from location state or currentView prop
  const previousView = location.state?.from || currentView; // Use location state if available, otherwise use currentView prop
  const goBackButtonText = previousView === 'card' ? 'Go Back To Card View' : 'Go Back To List View';

  console.log("initiativesIDxx", initiativesID);
  const handleGoBack = () => {
    if(id) {
      navigate('/InitiativeManagement', { state: { view: previousView } });
      return;
    }
    setIsEditing(false);
    setRefresh12((prev) => !prev);
  };

  useEffect(() => {
    if (id) {
      setInitiativeDetail(null);
      setRefresh((prev) => !prev); // Triggers re-fetch
    }
  }, [id]);

  useEffect(() => {
    setRefresh12(!refresh12);
  }, [refresh]);

  // Added By Madhuri.K On 09-10-2025 - Fetch Page Level Access API to filter tabs
  // Using api/PageAccess/Get to get the lstPageAcess which contains allowed tabs
  // Only tabs present in this response will be shown in UI
  useEffect(() => {
    const userdata = JSON.parse(sessionStorage.getItem("user"));
    console.log("Fetching Page Level Access - RoleId:", userdata?.roleId, "ParentTagId:", tagId);
    
    const fetchPageLevelAccess = async () => {
      try {
        // Corrected API endpoint to match the actual API being used
        const response = await AxiosInstance1.get(
          `/api/PageAccess/Get?RoleId=${userdata?.roleId}&ParentTagId=${tagId}`
        );
        console.log("Full API Response from /api/PageAccess/Get:", response.data);
        
        if (response.data && response.data.data && response.data.data.lstPageAcess) {
          setPageLevelAccess(response.data.data.lstPageAcess);
          console.log("✅ Page Level Access loaded successfully:", response.data.data.lstPageAcess);
          console.log("Number of allowed tabs:", response.data.data.lstPageAcess.length);
        } else {
          console.log("⚠️ No lstPageAcess found in API response");
        }
      } catch (error) {
        console.error("❌ Error fetching Page Level Access:", error);
      }
    };

    if (userdata?.roleId) {
      fetchPageLevelAccess();
    } else {
      console.log("⚠️ No roleId found in session storage");
    }
  }, [tagId]);

  // Added By Madhuri.K On 09-10-2025 - Fetch tabs based on Page Level Access API response
  // This useEffect handles tab visibility based on API response from GetInitiativeDetail
  // Only tabs with applicable: 1 will be shown in UI
  // If Work Order Details and Stage tabs are not in the API response, they will be hidden automatically
  useEffect(() => {
    const userdata = JSON.parse(sessionStorage.getItem("user"));
    setUserID(userdata?.employeeId);

    const fetchData = async () => {
      try {
        // Added by Gauri to add loader on 14 Nov 2025
        setInitialLoading(true);
        const detail = await GetInitiativeDetail(
          initiativesID || initiativeId,
          userdata?.employeeId
        );

        // Added By Madhuri.K On 09-10-2025 - Set tabs data from the API response (listInitiativeDetailSubtagEntity)
        // This ensures only tabs returned by API are displayed
        const tabs = detail.data.listInitiativeDetailSubtagEntity.map(
          (tab) => ({
            id: tab.subTagName.toLowerCase().replace(" ", "-"), // Generating an ID from subTagName
            title: tab.subTagName,
            api: tab.api,
            applicable: tab.applicable,
            subTagID: tab.subTagID,
          })
        );

        // Always include basic details
        tabs.unshift({
          id: "basic-details",
          title: "Basic Details",
          api: null, // No API for Basic Details
          applicable: 1, // Always applicable
        });

        // Added By Madhuri.K On 09-10-2025 - Filter tabs based on:
        // 1. applicable property from GetInitiativeDetail API
        // 2. Page Level Access API response (lstPageAcess)
        // Work Order Details and Stage tabs will be hidden if not present in Page Level Access
        
        // Added By Madhuri.K On 09-10-2025
        // Filter tabs based on Page Level Access API if available
        // Work Order Details and Stage tabs will be explicitly hidden if not in Page Level Access
        
        let filteredTabs = tabs.filter((tab) => tab.applicable);
        
        console.log("=== TAB FILTERING DEBUG ===");
        console.log("pageLevelAccess length:", pageLevelAccess?.length || 0);
        console.log("pageLevelAccess data:", pageLevelAccess);
        console.log("All tabs from GetInitiativeDetail (after applicable filter):", filteredTabs.map(t => ({
          title: t.title,
          id: t.id
        })));
        
        // Extract allowed tab names from Page Level Access API
        // Normalize by converting to lowercase and trimming spaces
        const allowedTabNames = pageLevelAccess && pageLevelAccess.length > 0 
          ? pageLevelAccess.map(access => access.tagname.toLowerCase().trim())
          : [];
        
        console.log("Allowed Tab Names from Page Level Access API:", allowedTabNames);
        
        // Filter tabs based on Page Level Access
        // Always filter out Work Order Details and Stage if not in allowed list
        const accessFilteredTabs = filteredTabs.filter((tab) => {
          // Always show Basic Details (Initiative tab)
          if (tab.id === "basic-details") return true;
          
          // Normalize tab name for comparison (lowercase, trim)
          const tabNameNormalized = tab.title.toLowerCase().trim();
          
          // Added By Madhuri.K On 09-10-2025 - Explicitly block Work Order Details and Stage
          // if they're not in the Page Level Access list
          if (allowedTabNames.length > 0) {
            // Page Level Access is available, use it for filtering
            const isAllowed = allowedTabNames.includes(tabNameNormalized);
            console.log(`Checking Tab: "${tab.title}" | Normalized: "${tabNameNormalized}" | Allowed: ${isAllowed}`);
            return isAllowed;
          } else {
            // If Page Level Access is not loaded, explicitly hide Work Order Details and Stage
            const tabsToHide = ["work order details", "stage"];
            const shouldHide = tabsToHide.includes(tabNameNormalized);
            
            if (shouldHide) {
              console.log(`⚠️ Hiding Tab: "${tab.title}" - Not in default allowed list`);
              return false;
            }
            
            console.log(`✅ Showing Tab: "${tab.title}" - Allowed by default`);
            return true;
          }
        });
        
        console.log("Final filtered tabs:", accessFilteredTabs.map(t => t.title));
        console.log("=== END TAB FILTERING ===");
        setTabsData(accessFilteredTabs);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        // Added by Gauri to add loader on 14 Nov 2025
        setInitialLoading(false);
      }
    };

    fetchData();
  }, [initiativesID, initiativeId, pageLevelAccess]);

  const updateTabsToShow = () => {
    const width = window.innerWidth;
    if (width >= 1200) {
      setTabsToShow(10);
    } else if (width >= 992) {
      setTabsToShow(8);
    } else {
      setTabsToShow(4);
    }
  };

  useEffect(() => {
    updateTabsToShow();
    window.addEventListener("resize", updateTabsToShow);
    return () => {
      window.removeEventListener("resize", updateTabsToShow);
    };
  }, []);

  useEffect(() => {
    const userdata = JSON.parse(sessionStorage.getItem("user"));
    setUserID(userdata?.employeeId);
  }, []);

  useEffect(() => {
    if (userID) {
      const fetchData = async () => {
        console.log("GetInitiativeDocumentList", activeTab);
        try {
          // Added by Gauri to add loader on 14 Nov 2025
          setTabLoading(true);
          if (activeTab == "basic-details") {
            setInitiativeDetail(null);
            const detail = await GetInitiativeDetail(initiativesID || initiativeId, userID);
            const datetime = new Date().getTime();
            const imageFieldIndex = detail?.data?.listInitiativeDetailEntity?.findIndex(
              field => field.actualFieldName === "InitiativeImage"
            );
            if (imageFieldIndex !== -1) {
              const originalUrl = detail.data.listInitiativeDetailEntity[imageFieldIndex].controlValue;

              // Remove existing query params if any, and append new timestamp
              const cleanUrl = originalUrl.split('?')[0];
              detail.data.listInitiativeDetailEntity[imageFieldIndex].controlValue = `${cleanUrl}?t=${datetime}`;
            }
            setInitiativeDetail(detail);
            // const filteredDetail = {
            //   ...detail,
            //   listInitiativeDetailEntity: detail.listInitiativeDetailEntity.map((item) => {
            //     if (item.fieldName === "BusinessUnitID") {
            //       return {
            //         ...item,
            //         initiativeDetailDropDownEntity: []
            //       };
            //     }
            //     return item;
            //   }),
            // };
            {
              /* Set initiativesData by Gauri for manage workflow stages on 24 Mar 2025 */
            }
            setInitiativesData(initiatives);
          }
          if (activeTab == "roi") {
            const roi = await GetInitiativeROIList(initiativesID || initiativeId);
            setInitiativeROI(roi);
          }
          // Commented By Madhuri.K On 09-10-2025 - Stage tab API call removed
          // Stage tab is hidden from UI based on Page Level Access API response
          // If stage tab is not present in listInitiativeDetailSubtagEntity from API, it won't be displayed
          // if (activeTab == "stage") {
          //   const stage = await GetInitiativeStageList(initiativesID || initiativeId);
          //   setInitiativeStage(stage);
          // }
          if (activeTab == "document-upload") {
            console.log("GetInitiativeDocumentList");
            const document = await GetInitiativeDocumentList(
              initiativesID || initiativeId,
              userID
            );
            setInitiativeDocument(document);
          }
          if (activeTab == "timelines") {
            const timeline = await GetInitiativeTimeline(initiativesID || initiativeId, userID);
            setInitiativeTimeline(timeline);
          }
          if (activeTab == "resources") {
            const resource = await GetInitiativeResourceList(initiativesID || initiativeId);
            setInitiativeResource(resource);
          }
          if (activeTab == "costs") {
            const cost = await GetInitiativeCostList(initiativesID || initiativeId);
            setInitiativeCost(cost);
          }
          // Commented By Madhuri.K On 09-10-2025 - Work Order Details tab API call removed
          // Work Order Details tab is hidden from UI based on Page Level Access API response
          // If work-order details tab is not present in listInitiativeDetailSubtagEntity from API, it won't be displayed
          // if (activeTab == "work-order details") {
          //   const workOrder = await GetInitiativeWorkOrderList(initiativesID || initiativeId);
          //   setInitiativeWorkOrder(workOrder);
          // }
          if (activeTab == "funding") {
            const fund = await GetInitiativeFundList(initiativesID || initiativeId);
            setInitiativeFund(fund);
          }
          if (activeTab == "discussion-thread") {
            const discussion = await GetInitiativeDiscussion(initiativesID || initiativeId);
            setInitiativeDiscussion(discussion);
          }
          // Modified by Gauri to change tab from initiative-history to workflow-history on 20 Nov 2025
          // if (activeTab == "initiative-history") {
          if (activeTab == "workflow-history") {
            const history = await GetInitiativeHistory(initiativesID || initiativeId, 1);
            setInitiativeHistory(history);
          }
          if (activeTab == "basic-details") {
            const linkAccess = await GetInitiativeLinkAccess(
              initiativesID || initiativeId,
              userID,
              IsConverted
            );
            setInitiativeLinkAccess(linkAccess);
          }
          if (activeTab == "workflows") {
            const workFlow = await GetInitiativeWorkFlow(initiativesID || initiativeId);
            setInitiativeWorkFlow(workFlow);
          }
          // Changed risks To risks/action-items By Madhuri.KOn 18-04-2025
          if (activeTab == "risks/action-items") {
            const risks = await GetInitiativeRisks(initiativesID || initiativeId, userID);
            setInitiativeRisks(risks);
          }
          if (activeTab == "risks/action-items") {
            const risksheat = await GetInitiativeRisksHeat(
              initiativesID || initiativeId,
              userID
            );
            setInitiativeRisksHeat(risksheat);
          }
          if (activeTab == "risks/action-items") {
            const actioItems = await GetInitiativeActioItems(
              initiativesID || initiativeId,
              userID
            );
            setInitiativeActioItems(actioItems);
          }
          if (activeTab == "basic-details") {
            const PrioritizationCheckList = await GetPrioritizationCheckList(
              initiativesID || initiativeId,
              userID
            );
            setPrioritizationCheckList(PrioritizationCheckList);
          }
        } catch (error) {
          console.error("Error fetching data:", error);
        } finally {
          // Added by Gauri to add loader on 14 Nov 2025
          setTabLoading(false);
        }
      };

      fetchData();
    }
  }, [userID, initiativesID, initiativeId, activeTab, refresh]);

  const toggleShowMore = () => {
    setShowMore(!showMore);
  };

  const handleTabClick = (tabId, subTagID) => {
    setActiveTab1(subTagID);
    setActiveTab(tabId);
  };
  useEffect(() => {
    if (userID && activeTab1) {
      const fetchSubTabLinkAccess = async () => {
        try {
          const response = await AxiosInstance1.get(
            `/api/InitiativeDetail/GetSubTabLinkAccess?IdeaID=${initiativesID || initiativeId}&UserID=${userID}&SubTagId=${activeTab1}`,
            {
              // method: "GET",
              headers: {
                accept: "*/*",
                // Authorization: `Bearer ${sessionStorage.getItem(
                //   "access_token"
                // )}`,
              },
            }
          );

          if (response.status !== 200) {
            throw new Error("Network response was not ok");
          }

          const data = response?.data;
          console.log(
            "SubTabLinkAccess Data:",
            data.data.initiativeSubTagLinkAccess
          );
          setAcc(data?.data?.initiativeSubTagLinkAccess);
          // You can set the data to state if needed
          // setSomeState(data);
        } catch (error) {
          console.error("Error fetching SubTabLinkAccess data:", error);
        }
      };

      fetchSubTabLinkAccess();
    }
  }, [activeTab1, initiativesID, initiativeId, userID]);

  const renderTabs = () => {
    return (
      <>
        {tabsData.map((tab) => (
          <Nav.Item key={tab.id}>
            <Nav.Link
              href={`#${tab.id}`}
              onClick={() => handleTabClick(tab.id, tab.subTagID)}
              active={activeTab === tab.id}
            >
              {tab.title}
            </Nav.Link>
          </Nav.Item>
        ))}
      </>
    );
  };

  const handleFieldChange = (value, stateKey) => {
    console.log("Selected Date22:", value, stateKey);
    setFormDataState({ ...formDataState, [stateKey]: value });
  };

  console.log("initiativeLinkAccess", initiativeLinkAccess);
  
  // Added By Madhuri.K On 09-10-2025 - Render content based on active tab
  // Tab visibility is controlled by Page Level Access API response (listInitiativeDetailSubtagEntity)
  // Only tabs with applicable: 1 are displayed in the UI (filtered in line 176)
  // Work Order Details and Stage tabs are hidden if not present in API response
  // Even though switch cases exist for hidden tabs, they won't execute as tabs won't be rendered in navigation
  const renderContent = () => {
    console.log("Risks", activeTab);
    switch (activeTab) {
      case "basic-details":
        return (
          <div className="container-fluid mt-3">
            {/* Passed initiativesData by Gauri for manage workflow stages on 24 Mar 2025 */}
            <BasicDetailEdit
              initiativesID={initiativesID || initiativeId}
              initiativeLinkAccess={initiativeLinkAccess}
              initiativeDetail={initiativeDetail}
              setInitiativeDetail={setInitiativeDetail}
              formData={formData}
              buttonData={buttonData}
              handleFieldChange={handleFieldChange}
              handleGoBack={handleGoBack}
              image={image}
              setRefresh1={setRefresh}
              refresh={refresh}
              setRefresh12={setRefresh12}
              refresh12={refresh12}
              prioritizationCheckList={prioritizationCheckList}
              initiativeActioItems={initiativeActioItems}
              initiativesData={initiativesData}
              // Added By Madhuri.K On 08-07-2025
              natureofDemandID={natureofDemandID}
              natureOfDemandRevisionID={natureOfDemandRevisionID}
              natureofDemand={natureofDemand}
            />
          </div>
        );
      case "resources":
        return (
          <div className="container-fluid mt-3">
            <ResourceEdit
              initiativeResource={initiativeResource}
              initiativesID={initiativesID || initiativeId}
              setRefresh1={setRefresh}
              refresh={refresh}
              show={show}
              acc={acc}
            />
            <Stack
              horizontal
              horizontalAlign="end"
              tokens={{ childrenGap: 10 }}
            ></Stack>
          </div>
        );
      // Added By Madhuri.K On 09-10-2025 - Work Order Details tab case kept for backward compatibility
      // This case won't be executed if Work Order Details tab is not in Page Level Access API response
      // Work Order Details tab is hidden by filtering in line 176 based on applicable property
      case "work-order details":
        return (
          <div className="container-fluid mt-3">
            <WorkOrderTab
              initiativeWorkOrder={initiativeWorkOrder}
              initiativesID={initiativesID || initiativeId}
              setRefresh1={setRefresh}
              refresh={refresh}
              show={show}
              acc={acc}
              viewPermission={workOrderTabPermission}
            />
            <Stack
              horizontal
              horizontalAlign="end"
              tokens={{ childrenGap: 10 }}
            ></Stack>
          </div>
        );
      case "costs":
        return (
          <div className="container-fluid mt-3">
            <CostTabContent
              costData={initiativeCost}
              initiativesID={initiativesID || initiativeId}
              setRefresh1={setRefresh}
              refresh={refresh}
              show={show}
              acc={acc}
            />
            <Stack
              horizontal
              horizontalAlign="end"
              tokens={{ childrenGap: 10 }}
            ></Stack>
          </div>
        );
      case "funding":
        return (
          <div className="container-fluid mt-3">
            <FundingTab
              fundData={initiativeFund}
              initiativesID={initiativesID || initiativeId}
              setRefresh1={setRefresh}
              refresh={refresh}
              show={show}
              acc={acc}
            />
            <Stack
              horizontal
              horizontalAlign="end"
              tokens={{ childrenGap: 10 }}
            ></Stack>
          </div>
        );
      case "roi":
        return (
          <div className="container-fluid mt-3">
            <ROIComponent
              initiativeROI={initiativeROI}
              initiativesID={initiativesID || initiativeId}
              // Added by Gauri to pass Initiative details to ROI on 07 Mar 2025
              initiativeDetail={initiativeDetail}
              setRefresh1={setRefresh}
              refresh={refresh}
              show={show}
              acc={acc}
            />
            <Stack
              horizontal
              horizontalAlign="end"
              tokens={{ childrenGap: 10 }}
            ></Stack>
          </div>
        );
      // Added By Madhuri.K On 09-10-2025 - Stage tab case kept for backward compatibility
      // This case won't be executed if Stage tab is not in Page Level Access API response
      // Stage tab is hidden by filtering in line 176 based on applicable property
      case "stage":
        return (
          <div className="container-fluid mt-3">
            <StageComponent
              stageData={initiativeStage}
              setRefresh1={setRefresh}
              refresh={refresh}
              acc={acc}
            />
            <Stack
              horizontal
              horizontalAlign="end"
              tokens={{ childrenGap: 10 }}
            ></Stack>
          </div>
        );
      case "timelines":
        return (
          <div className="container-fluid mt-3">
            <TimelinesComponent
              initiativeTimeline={initiativeTimeline}
              initiativesID={initiativesID || initiativeId}
              setRefresh1={setRefresh}
              refresh={refresh}
              show={show}
              acc={acc}
            />
            <Stack
              horizontal
              horizontalAlign="end"
              tokens={{ childrenGap: 10 }}
            ></Stack>
          </div>
        );
      case "document-upload":
        return (
          <div className="container-fluid mt-3">
            <DocumentsComponent
              initiativeDocument={initiativeDocument}
              initiativesID={initiativesID || initiativeId}
              setRefresh={setRefresh}
              show={show}
              refresh={refresh}
              acc={acc}
              viewPermission={docTabPermission}
            />
            <Stack
              horizontal
              horizontalAlign="end"
              tokens={{ childrenGap: 10 }}
            ></Stack>
          </div>
        );
      case "workflows":
        return (
          <div className="container-fluid mt-3">
            <WorkflowTabs initiativeWorkFlow={initiativeWorkFlow} acc={acc} />
            <Stack
              horizontal
              horizontalAlign="end"
              tokens={{ childrenGap: 10 }}
            ></Stack>
          </div>
        );
      case "discussion-thread":
        return (
          <div className="container-fluid mt-3">
            <Discussion initiativeId={initiativesID || initiativeId} acc={acc} />
            <Stack
              horizontal
              horizontalAlign="end"
              tokens={{ childrenGap: 10 }}
            ></Stack>
          </div>
        );
      // Modified by Gauri to change tab from initiative-history to workflow-history on 20 Nov 2025
      // case "initiative-history":
      case "workflow-history":
        return (
          <div className="container-fluid mt-3">
            <InitiativeHistoryTab initiativeId={initiativesID || initiativeId} acc={acc} />
            <Stack
              horizontal
              horizontalAlign="end"
              tokens={{ childrenGap: 10 }}
            ></Stack>
          </div>
        );
      // Changed risks To risks/action-items By Madhuri.KOn 18-04-2025
      case "risks/action-items":
        return (
          <div className="container-fluid mt-3">
            <MoreActions
              initiativesID={initiativesID || initiativeId}
              initiativeActioItems={initiativeActioItems}
              initiativeRisks={initiativeRisks}
              initiativeRisksHeat={initiativeRisksHeat}
              // Passed initiativeDetail to get requestStageId by Gauri on 12 Mar 2025
              initiativeDetail={initiativeDetail}
              setRefetch={setRefresh}
              refetch={refresh}
              show={show}
              acc={acc}
            />
            <Stack
              horizontal
              horizontalAlign="end"
              tokens={{ childrenGap: 10 }}
            ></Stack>
          </div>
        );
      default:
        return (
          <div>
            <h3>{tabData.find((tab) => tab.id === activeTab)?.title}</h3>
            <p>
              Content related to{" "}
              {tabData.find((tab) => tab.id === activeTab)?.title.toLowerCase()}{" "}
              goes here.
            </p>
          </div>
        );
    }
  };

  // Added by Gauri to add loader on 14 Nov 2025 - Show loader on initial page load or while permissions are loading
  if (initialLoading || permissionsLoading) {
    return (
      <>
        <div className="loader-wrap"><div className="uiverse-loader small"><div className="ring"></div><div className="ring"></div><div className="ring"></div><div className="ring"></div></div></div>
      </>
    );
  }

  return (
    <div style={{ marginBottom: "1em" }}>
      {/* ClassName custom-nav-tabs Added By Madhuri.K on 18-04-2025 */}
      <div id="IMInfopgtabs" className="IM_tabs bglightblue custom-nav-tabs" style={{ position: "relative", paddingRight: "200px", zIndex: 0 }}>
        {/* Go Back Button - Positioned in top-right corner - Added By Madhuri.K on 09-10-2025 */}
        <button
          onClick={handleGoBack}
          className="download-file-button"
          style={{
            position: "absolute",
            top: "50%",
            right: "10px",
            transform: "translateY(-50%)",
            fontSize: "11px",
            padding: "6px 12px",
            display: "inline-flex",
            alignItems: "center",
            gap: "4px",
            lineHeight: "1.2",
            border: "1px solid #0078d4",
            borderRadius: "4px",
            background: "#fff",
            color: "#0078d4",
            cursor: "pointer",
            transition: "all 0.2s ease",
            height: "fit-content"
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = "#0078d4";
            e.currentTarget.style.color = "#fff";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = "#fff";
            e.currentTarget.style.color = "#0078d4";
          }}
        >
          <ArrowBackIcon style={{ fontSize: "12px" }} />
          {goBackButtonText}
        </button>
        
        <Nav variant="tabs" defaultActiveKey={`#${tabData[0]?.id}`}>
          {renderTabs()}
        </Nav>
      </div>
      {/* Added by Gauri to add loader on 14 Nov 2025 - Show loader when switching tabs */}
      {tabLoading ? (
        <div className="loader-wrap"><div className="uiverse-loader small"><div className="ring"></div><div className="ring"></div><div className="ring"></div><div className="ring"></div></div></div>
      ) : (
        renderContent()
      )}
    </div>
  );
};

export default EditPage;

export const EditPageWrapper = () => {
  const location = useLocation();
  return <EditPage key={location.pathname} />;
};
